<div class="main-container">
  <div class="ui grid">
    <div class="sixteen wide mobile eleven wide tablet eleven wide computer column">
      <h1>
        <i class="setting icon"></i>
        Settings
      </h1>
    </div>

    <div class="sixteen wide mobile five wide tablet right floated four wide computer column">
      <a class="ui fluid right floated primary button new-task" v-on:click="newTask" v-if="type === 'company' || $store.getters['user/isCatalogEditor']">New Task</a>
    </div>

    <!-- Sidebar Menu -->
    <div class="sixteen wide mobile four wide tablet four wide computer column settings-side-menu">
      <app-setting-sidebar active_tab="task">
      </app-setting-sidebar>
    </div>

    <div class="sixteen wide mobile twelve wide tablet twelve wide computer column settings-main-content">
      <div class="ui top attached tabular menu">
        <div class="item active" data-tab="first" @click="type = 'default'">Default</div>
        <div class="item" data-tab="second" @click="type = 'company'" v-if="!$store.getters['user/isCatalogEditor']">Custom</div>
      </div>

      <!-- Tab 1 -->
      <div class="ui bottom attached tab segment active" data-tab="first">
        <form class="ui form settings">

          <div class="two fields">
            <div class="field settings">
              <label>Search Tasks</label>
              <app-text-input
                icon="search"
                placeholder="Search"
                v-model="searchText"
                v-on:keyup="search">
              </app-text-input>
            </div>

            <div class="field settings">
              <label>Filter by Type</label>
              <app-select :defaultLabel="'All Tasks'" :default-selectable="true" :value="''" :items="$store.getters['task/getTypes']"
                @selected="filterByType($event.id)">
              </app-select>
            </div>
          </div>

          <table class="ui basic sortable selectable celled padded table">
            <tbody>
              <template v-if="!filterType && searchText.length == 0 && searchResults.length == 0">
                <tr
                  v-for="task in tasks"
                  :key="'all-' + task.id"
                  class="show-view-task-all"
                  v-on:click="viewTask(task)"
                >
                  <td>
                    <img v-if="task.images && task.images.length > 0" :src="getImageUrl(task)" width="32px" height="32px">
                    <img v-else src="../../assets/img/no-image-available.jpg" width="32px" height="32px">
                  </td>
                  <td>{{ task.name }}</td>
                </tr>
              </template>
              <template v-else-if="(filterType || searchText.length != 0) && searchResults.length != 0">
                <tr
                  v-for="task in searchResults"
                  :key="'search-' + task.id"
                  class="show-view-task-all"
                  v-on:click="viewTask(task)"
                >
                  <td>
                    <img v-if="task.images && task.images.length > 0" :src="getImageUrl(task)" width="32px" height="32px">
                    <img v-else src="../../assets/img/no-image-available.jpg" width="32px" height="32px">
                  </td>
                  <td>{{ task.name }}</td>
                </tr>
              </template>
              <tr v-if="tasks.length === 0 && !loading" class="empty-state-row">
                <td colspan="2" class="center aligned">
                  <div class="empty-state-container">
                    <div class="empty-state-content">
                      <h3 class="empty-state-title">No tasks found</h3>
                      <p class="empty-state-description">
                        <span v-if="type === 'default'">Default tasks will appear here</span>
                        <span v-else-if="type === 'company'">Custom created tasks will appear here</span>
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
            </tfoot>
          </table>
          <app-loader v-if="tasks.length == 0 && loading"></app-loader>
        </form>
        <div v-if="tasks.length > 0" class="sixteen wide column pagination-controls">
          <app-pagination
            :page="paginator.page"
            :total-pages="paginator.totalPages"
            @change="onPageChange"
          />
        </div>
      </div>

      <!-- Tab 2 -->
      <div class="ui bottom attached tab segment" data-tab="second">
        <form class="ui form settings">

          <div class="two fields">
            <div class="field settings">
              <label>Search Tasks</label>
              <app-text-input
                icon="search"
                placeholder="Search"
                v-model="searchText"
                v-on:keyup="search">
              </app-text-input>
            </div>

            <div class="field settings">
              <label>Filter by Type</label>
              <app-select :defaultLabel="'All Tasks'" :default-selectable="true" :value="''" :items="$store.getters['task/getTypes']"
                @selected="filterByType($event.id)">
              </app-select>
            </div>
          </div>

          <table class="ui basic sortable selectable celled padded table">
            <tbody>
              <template v-if="!filterType && searchText.length == 0 && searchResults.length == 0">
                <tr
                  v-for="task in tasks"
                  :key="'tab2-all-' + task.id"
                  class="show-view-task-all"
                  v-on:click="viewTask(task)"
                >
                  <td>
                    <img v-if="task.images && task.images.length > 0" :src="getImageUrl(task)" width="32px" height="32px">
                    <img v-else src="../../assets/img/no-image-available.jpg" width="32px" height="32px">
                  </td>
                  <td>{{ task.name }}</td>
                </tr>
              </template>
              <template v-else-if="(filterType || searchText.length != 0) && searchResults.length != 0">
                <tr
                  v-for="task in searchResults"
                  :key="'tab2-search-' + task.id"
                  class="show-view-task-all"
                  v-on:click="viewTask(task)"
                >
                  <td>
                    <img v-if="task.images && task.images.length > 0" :src="getImageUrl(task)" width="32px" height="32px">
                    <img v-else src="../../assets/img/no-image-available.jpg" width="32px" height="32px">
                  </td>
                  <td>{{ task.name }}</td>
                </tr>
              </template>
              <tr v-if="tasks.length === 0 && !loading" class="empty-state-row">
                <td colspan="2" class="center aligned">
                  <div class="empty-state-container">
                    <div class="empty-state-content">
                      <h3 class="empty-state-title">No tasks found</h3>
                      <p class="empty-state-description">
                        <span v-if="type === 'default'">Default tasks will appear here</span>
                        <span v-else-if="type === 'company'">Custom created tasks will appear here</span>
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
            </tfoot>
          </table>
          <app-loader v-if="tasks.length === 0 && loading"></app-loader>
        </form>
          <div v-if="tasks.length > 0" class="sixteen wide column pagination-controls">
            <app-pagination
              :page="paginator.page"
              :total-pages="paginator.totalPages"
              @change="onPageChange"
            />
          </div>
      </div>
    </div>
  </div>
</div>
